import React, { useState, useEffect, useMemo } from 'react';
import { useTable } from 'react-table';
import Pagination from '../../shared/pagination/index';
import { RiDeleteBin5Line, RiPencilLine, RiAddFill } from "react-icons/ri";
import '../../../../src/index.css'; 
import { getScaleModel, deleteScaleModelId, createScaleModel, updateScaleModelId } from '../../../client/administration/scaleModel/index';
import { getScaleBrand } from '../../../client/administration/scaleBrand';
import buttonClose from "../../../assets/images/shared/modals/button-close.svg";
import AddData from '../../shared/alertRegisterData/index';
import DeleteData from '../../shared/alertDeleteData/index';
import EditData from '../../shared/alertEditData/index';
import InputField from 'components/forms/inputField';
import SelectField from 'components/forms/selectField';

const TableScaleModel = ({ recordsPerPage, data, currentPage, filterModelName, filterBrandName, setCurrentPage, searchTerm, onSearchTermChange,  showModalAddScale, closeModalAddScale}) => {
  
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [scaleModels, setScaleModels] = useState([]);

  const totalRecords = scaleModels.length;

  const [modelName, setModelName] = useState('');
  const [maximunCapacity, setMaximunCapacity] = useState('');
  const [minimunCapacity, setMinimunCapacity] = useState('');
  const [idScaleBrand, setIdScaleBrand] = useState('');
    
  const [showModalAddData, setShowModalAddData] = useState(false);

  const [editingScaleModel, setEditingScaleModel] = useState(null); 
  const [showEditConfirmModal, setShowEditConfirmModal] = useState(false);
  const [showModalEditScaleModel, setShowModalEditScaleModel] = useState(false); 

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [scaleModelToDelete, setScaleModelToDelete] = useState(null); 

  const [errors, setErrors] = useState({
    modelName: false,
    maximunCapacity: false,
    minimunCapacity: false,
    idScaleBrand: false,
  });

  useEffect(() => {
    const fetchScaleModels = async () => {
      setLoading(true);
      try {
        const { data } = await getScaleModel();
        setScaleModels(data);
        setError(null);
      } catch (err) {
        setError(err.message || "Error al cargar los modelos");
      } finally {
        setLoading(false);
      }
    };

    fetchScaleModels();
  }, []);

/************** FILTROS DE BUSQUEDA  *******************/

    useEffect(() => {
      const filteredData = data.filter(scaleModel => {

      const matchesBrandName = filterBrandName ? 
      scaleModel.scaleBrand && 
      scaleModel.scaleBrand.brandName && 
      scaleModel.scaleBrand.brandName.includes(filterBrandName) : true;
      
      const matchesModelName = filterModelName ? 
      scaleModel.modelName.toLowerCase().includes(filterModelName.toLowerCase()) : true;

      const matchesSearchTerm = searchTerm ? 
      scaleModel.modelName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      scaleModel.minimunCapacity.toString().includes(searchTerm.toLowerCase()) ||
      scaleModel.maximunCapacity.toString().includes(searchTerm.toLowerCase()) ||
      (scaleModel.scaleBrand && scaleModel.scaleBrand.brandName && scaleModel.scaleBrand.brandName.toLowerCase().includes(searchTerm.toLowerCase()))
      : true;

        return matchesModelName && matchesBrandName && matchesSearchTerm
        ;
      });
  
      setScaleModels(filteredData);
      setLoading(false);
    }, [data, filterModelName, filterBrandName, searchTerm]); 
    

  /***AGREGAR REGISTRO*******/

  const handleSaveScaleModel = async () => {

    const newErrors = {
      modelName: !modelName || modelName.length < 3 || modelName.length > 45,
      maximunCapacity: !maximunCapacity || isNaN(maximunCapacity),           // Validación de número
      minimunCapacity: !minimunCapacity || isNaN(minimunCapacity), 
      idScaleBrand: !idScaleBrand,
    };


    setErrors(newErrors);
    if (Object.values(newErrors).some(error => error)) {
      return;
    }

    const newScaleModel = {
      modelName: modelName,
      maximunCapacity: maximunCapacity,
      minimunCapacity: minimunCapacity,
      idScaleBrand: parseInt(idScaleBrand, 10),
    };
   // console.log("Datos a enviar:", newScaleModel); // Esta línea imprime los datos en la consola

    try {
      const { data } = await createScaleModel(newScaleModel); 
      const {data: updatedScaleModels} = await getScaleModel();
      setScaleModels(updatedScaleModels)
      setModelName('');
      setMaximunCapacity('');
      setMinimunCapacity('');
      setIdScaleBrand('');
     // setShowModalAddScaleModel(false);
      closeModalAddScale();
      setShowModalAddData(true);

      onSearchTermChange(searchTerm);
    } catch (err) {
     // setError("Error al agregar el modelo: " + err.message);
    }
  };

    /**EDITAR REGISTRO */
 const openModalEditScaleModel = () => {
  setShowModalEditScaleModel(true);
};

const closeModalEditScaleModel = () => {
  setShowModalEditScaleModel(false);
};
 const [editedScaleModel, setEditedScaleModel] = useState({
   id: '',
   modelName: '',
   maximunCapacity: '',
   minimunCapacity: '',
   idScaleBrand: '',
 });

 const handleEditClick = (row) => {
   setEditingScaleModel(row);
   setEditedScaleModel({
     id: row.original.id,
     modelName: row.original.modelName,
     maximunCapacity: row.original.maximunCapacity,
     minimunCapacity: row.original.minimunCapacity,
     idScaleBrand: row.original.idScaleBrand,
   });
 //  console.log(row.original);
 };


 const handleEditSubmit = async (e) => {
   e.preventDefault();
   const newErrors = {
    modelName: !editedScaleModel.modelName || editedScaleModel.modelName.length < 3 || editedScaleModel.modelName.length > 45,
    maximunCapacity: !editedScaleModel.maximunCapacity || isNaN(editedScaleModel.maximunCapacity),           // Validación de número
    minimunCapacity: !editedScaleModel.minimunCapacity || isNaN(editedScaleModel.minimunCapacity), 
    idScaleBrand: !editedScaleModel.idScaleBrand,
  };

  setErrors(newErrors);
  if (Object.values(newErrors).some(error => error)) {
      return;
  }

   setShowEditConfirmModal(true);
 };


/** ELIMINAR */

  const deleteScaleModelHandler = (row) => {
  //  console.log("Registro seleccionado para eliminar:", row.original);
    setScaleModelToDelete(row.original); 
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    try {
      if (!scaleModelToDelete?.id) throw new Error("ID no encontrado");
      await deleteScaleModelId(scaleModelToDelete.id); // Usa el id para la eliminación en el backend
      setScaleModels(prevData => prevData.filter(item => item.id !== scaleModelToDelete.id)); // Actualiza la tabla localmente
      setShowDeleteModal(false); 
  } catch (error) {
      console.error("Error al eliminar:", error);
      //alert("No se pudo eliminar el registro.");
  }
  };
  
    /***************OBTENER LISTA MARCAS********************/
    const [scaleBrands, setScaleBrands] = useState([]);
    useEffect(() => {
      const fetchScaleBrands = async () => {
        try {
          const { data } = await getScaleBrand(); 
          setScaleBrands(data);
        } catch (err) {
          setError(err.message || "Error al cargar los modelos");
        }
      };
      fetchScaleBrands();
    }, []);

/**PAGINACION */

const totalPages = Math.ceil(totalRecords / recordsPerPage);

const changePage = (newPage) => {
  if (newPage >= 1 && newPage <= totalPages) {
    setCurrentPage(newPage);
  }
};

  /**COLUMNAS */
  const columns = useMemo(
    () => [
      { Header: 'ID', accessor: 'id', style: { width: '50px' } },
      { Header: 'Modelo', accessor: 'modelName', style: { width: '260px' } },
      { Header: 'Capacidad max', accessor: 'maximunCapacity', style: { width: '200px' } },
      { Header: 'Capacidad min', accessor: 'minimunCapacity', style: { width: '200px' } },
      { Header: 'Marca', accessor: 'scaleBrand.brandName', style: { width: '200px' }},
      { Header: 'Fecha de registro', accessor: 'createdAt' ,  style: { width: '130px' } ,
      Cell: ({ value }) => {
        const date = new Date(value); 
        const formattedDate = date.toISOString().slice(0, 10); 
        const formattedTime = date.toTimeString().slice(0, 5); 
        return `${formattedDate} ${formattedTime}`;
      },},
      {
        Header: 'Editar',
        accessor: 'editar',
        style: { width: '90px' },
        Cell: ({ row }) => (
          <div className="flex items-center justify-center">
            <button
              onClick={() => handleEditClick(row)}
              className="p-2 flex justify-center items-center bg-[#EFEEF7]  hover:bg-[#D8D7E0]  rounded-[4px] border border-[#D9D9D9] w-12 h-12"
            >
              <RiPencilLine className="text-xl text-black" />
            </button>
          </div>
        ),
      },
      {
        Header: 'Eliminar',
        accessor: 'eliminar',
        style: { width: '90px' },
        Cell: ({ row }) => (
          <div className="flex items-center justify-center">
            <button
              onClick={() => deleteScaleModelHandler(row)}
              className="p-2 flex justify-center items-center bg-[#EFEEF7]  hover:bg-[#D8D7E0]  rounded-[4px] border border-[#D9D9D9] w-12 h-12"
            >
              <RiDeleteBin5Line className="text-xl text-black" />
            </button>
          </div>
        ),
      },
    ],
    []
  );

  const indexOfLastScaleModel = currentPage * recordsPerPage;
  const indexOfFirstScaleModel = indexOfLastScaleModel - recordsPerPage;
  const currentScaleModels = scaleModels.slice(indexOfFirstScaleModel, indexOfLastScaleModel);


  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable(
    {
      columns,
      data: currentScaleModels,
      initialState: { pageIndex: 0, pageSize: recordsPerPage || 10 },
    },

  );

 // if (loading) return <p>Cargando marcas...</p>;
 if (error) {
  return (
    <div className='items-center justify-center w-full min-h-full pt-16'>
      <p className='pt-4 text-2xl text-center text-error font-itcmedium'>
        Hubo un error al recuperar los datos.
      </p>
    </div>
  );
}

  return (
    <div className="w-full pt-4">
        {/**
        <button
          onClick={openModalAddScaleModel}
          className="flex items-center justify-center h-[40px] p-3 px-5 mb-4 space-x-4 text-white rounded-md bg-green"
          >
          <RiAddFill className="flex text-[14px] font-itcmedium" /> 
          Agregar modelo de balanza
        </button>
       */}
        {!error && scaleModels.length === 0 && (
        <div className='flex items-center justify-center w-full'>
         <p className='pt-4 text-xl text-center font-itcmedium'>No se hallaron registros.</p>
        </div>
         )}

        {/* Modal de agregar */}
        {showModalAddScale && (
          <div className="fixed inset-0 z-50 flex items-center justify-center w-full bg-black bg-opacity-50">
            <div className="lg:w-[40%] w-[90%] h-auto p-2 bg-white rounded-3xl shadow-lg flex flex-col">
              <div className="flex justify-end">
                <button
                  onClick={closeModalAddScale}
                  className="px-1 py-0 rounded-md"
                >
                  <img src={buttonClose} alt="Cerrar"/>
                </button>
              </div>
              <div className="flex flex-col items-center justify-center px-4 pb-4 space-y-4">
                <div className="flex justify-center w-full">
                <h1 className="mb-4 text-2xl text-blue font-itcbold">Agregar modelo de balanza</h1>
                </div>
                <div className="justify-center flex flex-col gap-4 w-[85%]">

                  <InputField
                    value={modelName}
                    placeholder="Nombre del modelo"
                    onChange={(e) => {
                      setModelName(e.target.value);
                      setErrors((prevErrors) => ({ ...prevErrors, modelName: false }));
                    }}
                    error={errors.modelName}
                    errorMessage= "Campo requerido"
                    minLength={3}
                    maxLength={45}
                    required
                  />

                  <InputField
                    value={maximunCapacity}
                    placeholder="Capacidad máxima"
                    onChange={(e) => {
                      setMaximunCapacity(e.target.value);
                      setErrors((prevErrors) => ({ ...prevErrors, maximunCapacity: false }));
                    }}
                    error={errors.maximunCapacity}
                    errorMessage= "Campo requerido"
                    minLength={3}
                    maxLength={45}
                    required
                  />

                  <InputField
                    value={minimunCapacity}
                    placeholder="Capacidad mínima"
                    onChange={(e) => {
                      setMinimunCapacity(e.target.value);
                      setErrors((prevErrors) => ({ ...prevErrors, minimunCapacity: false }));
                    }}
                    error={errors.minimunCapacity}
                    errorMessage= "Campo requerido"
                    minLength={3}
                    maxLength={45}
                    required
                  />

                  <SelectField
                    value={idScaleBrand}
                    options={scaleBrands.map((scaleBrand) => ({
                      value: scaleBrand.id,
                      label: scaleBrand.brandName
                    }))}
                    onChange={(e) => {
                      setIdScaleBrand(e.target.value);
                      setErrors((prevErrors) => ({ ...prevErrors, idScaleBrand: false }));
                    }}
                    error={errors.idScaleBrand}
                    errorMessage="Campo requerido"
                    required
                    placeholder="Marca"
                  />
                </div>
              </div>
              <div className="flex w-full py-4 pb-8 sm:px-[10%] justify-between gap-2">
              <button 
                  onClick={handleSaveScaleModel}
                  className="w-[160px] inline-block sm:h-[43px] h-[46px] text-md text-center text-white bg-green rounded-2xl font-itcdemi"
                >
                  Guardar
                </button>
                <button
                  onClick={closeModalAddScale}
                  className="w-[160px] inline-block sm:h-[43px] h-[46px] text-md text-center bg-white border-2 text-green rounded-2xl font-itcdemi border-green"
                >
                  Cancelar
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Modal de éxito */}
        {showModalAddData && (
          <AddData
            showModalAddData={showModalAddData}
            closeModalAddData={() => setShowModalAddData(false)}
          />
        )}

        {scaleModels.length > 0 && (
          <>
            {/* Tabla de modelo de balanzas*/}
            <div className="overflow-x-auto max-w-screen scroll-container">
              <table {...getTableProps()} className="w-full border-collapse table-fixed">
                <thead className="bg-white">
                  {headerGroups.map(headerGroup => (
                    <tr {...headerGroup.getHeaderGroupProps()} className="text-sm text-center font-itcbold">
                      {headerGroup.headers.map(column => (
                        <th
                          {...column.getHeaderProps()}
                          style={column.style}
                          className="px-4 py-2 border border-[#D9D9D9]"
                        >
                          {column.render('Header')}
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>
                <tbody {...getTableBodyProps()} className="table-row-group">
                  {rows.map(row => {
                    prepareRow(row);
                    return (
                      <tr
                        {...row.getRowProps()}
                        className={`text-sm border-collapse h-full font-itcmedium text-left ${row.index % 2 === 0 ? 'bg-white' : 'bg-[#EBEBEB]/[0.2]'}`}
                      >
                        {row.cells.map(cell => (
                          <td
                            {...cell.getCellProps()}
                            className="px-4 py-2 border border-[#D9D9D9]"
                          >
                            {cell.render('Cell')}
                          </td>
                        ))}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

            <div className="flex flex-col items-center justify-between mt-6 space-x-4 space-y-2 md:flex-row">
            <p className="text-[#1F2A37] text-sm font-itcbook">
            Mostrando registros del {(currentPage - 1) * recordsPerPage + 1} al{' '}
              {Math.min(currentPage * recordsPerPage, totalRecords)} de un total de {totalRecords} registros

            </p>

            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              changePage={changePage}
            />
            </div>
          </>
        )}


        {/* EDITAR REGISTRO */}
        {editingScaleModel && (
          <div className="fixed inset-0 z-50 flex items-center justify-center w-full bg-black bg-opacity-50">
            <div className="lg:w-[40%] w-[90%] h-auto p-2 bg-white rounded-3xl shadow-lg flex flex-col">
            <div className="flex justify-end">
                <button
                  onClick={closeModalEditScaleModel}
                  className="px-1 py-0 rounded-md"
                >
                  <img src={buttonClose} alt="Cerrar"/>
                </button>
              </div>
              <div className='flex flex-col items-center justify-center px-4 pb-4 space-y-4'>
                <div className='flex justify-center w-full'>
                <h3 className="mb-4 text-2xl font-bold text-blue font-itcbold">Editar modelo de balanza</h3>
                </div>
                <form onSubmit={handleEditSubmit} className=' w-[85%] justify-center' >
                  <div className='flex flex-col gap-4'>

                    <InputField
                      value={editedScaleModel.modelName}
                      placeholder="Modelo"
                      onChange={(e) =>
                        setEditedScaleModel((prevState) => ({
                          ...prevState,
                          modelName: e.target.value,
                        }))
                      }
                      error={errors.modelName}
                      errorMessage="Campo requerido"
                      minLength={3}
                      maxLength={45}
                      required
                    />

                    <InputField
                      value={editedScaleModel.maximunCapacity}
                      placeholder="Capacidad máxima"
                      onChange={(e) =>
                        setEditedScaleModel((prevState) => ({
                          ...prevState,
                          maximunCapacity: e.target.value,
                        }))
                      }
                      error={errors.maximunCapacity}
                      errorMessage="Campo requerido"
                      minLength={3}
                      maxLength={45}
                      required
                    />

                    <InputField
                      value={editedScaleModel.minimunCapacity}
                      placeholder="Capacidad mínima"
                      onChange={(e) =>
                        setEditedScaleModel((prevState) => ({
                          ...prevState,
                          minimunCapacity: e.target.value,
                        }))
                      }
                      error={errors.minimunCapacity}
                      errorMessage="Campo requerido"
                      minLength={3}
                      maxLength={45}
                      required
                    />

                    <SelectField
                      value={editedScaleModel.idScaleBrand}
                      options={scaleBrands.map((scaleBrand) => ({
                        value: scaleBrand.id,
                        label: scaleBrand.brandName,
                      }))}
                      onChange={(e) =>
                        setEditedScaleModel((prevState) => ({
                          ...prevState,
                          idScaleBrand: e.target.value,
                        }))
                      }
                      error={errors.idScaleBrand}
                      errorMessage="Campo requerido"
                      required
                      placeholder="Marca"
                    />

                  </div>
                  <div className="flex justify-between w-full gap-2 py-4 pt-8">
                      <button type="submit"
                      className="w-[160px] inline-block sm:h-[43px] h-[46px] text-md text-center text-white bg-green rounded-2xl font-itcdemi">
                          Guardar
                      </button> 
                
                      <button type="button"
                        onClick={() => setEditingScaleModel(null)}
                        className="w-[160px] inline-block sm:h-[43px] h-[46px] text-md text-center bg-white border-2 text-green rounded-2xl font-itcdemi border-green">
                          Cancelar
                      </button>   
                    </div>
                </form>
              </div>
            </div>
          </div>
        )}

        {showEditConfirmModal && (
            <EditData
                showModalEditData={showEditConfirmModal}
                closeModalEditData={() => setShowEditConfirmModal(false)}
                scalemodel={editedScaleModel.modelName}
                context="ModeloBalanzas"
                onConfirm={async () => {
                    try {
                        await updateScaleModelId(editedScaleModel.id, {
                            modelName: editedScaleModel.modelName,
                            maximunCapacity: editedScaleModel.maximunCapacity,
                            minimunCapacity: editedScaleModel.minimunCapacity,
                            idScaleBrand: editedScaleModel.idScaleBrand,
                        });
                        const {data: updatedScaleModel} = await getScaleModel();
                        setScaleModels(updatedScaleModel);
                        setEditingScaleModel(null);
                        setShowEditConfirmModal(false); 
                    } catch (err) {
                        setError("Error al actualizar el registro: " + err.message);
                    }
                }}
            />
        )}
        
        {/* Modal de eliminación */}
        {showDeleteModal && (
          <DeleteData
            showModalDeleteData={showDeleteModal}
            closeModalDeleteData={() => setShowDeleteModal(false)}
            context="ModeloBalanzas"
            scalemodel={scaleModelToDelete?.modelName}
            confirmDelete={confirmDelete}
          />
        )}


    </div>
  );
};

export default TableScaleModel;